import {HiOutlineMail} from 'react-icons/hi'
import {RiGithubFill} from 'react-icons/ri'
import {RiLinkedinFill} from 'react-icons/ri'

const data = [
    {id: 1, icon: <HiOutlineMail/>, link: 'mailto:amankwahalex22@gmail.com'},
    {id: 2, icon: <RiLinkedinFill/>, link: 'https://linkedin.com/in/alex-amankwah'},
    {id: 3, icon: <RiGithubFill/>, link: 'https://github.com/alexamankwah2'}
   
]



export default data